module.exports = __webpack_public_path__ + "static/media/reduxsagalogo.92e2135b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/reduxsagalogo.png
// module id = 819
// module chunks = 0